import checkFeatureFlag from 'utils/featureFlags';
export const isMiniValueProofEnabled = (featureFlags) => checkFeatureFlag(featureFlags, 'ab_mini_value_proof');
/**
 * The screens are built from a first bank import, so they only make sense for
 * a new user coming through sign-up — someone signing back in has already seen
 * the app.
 */
export const isEligibleForMiniValueProof = ({ featureFlags, signInNavigation, user, }) => isMiniValueProofEnabled(featureFlags) &&
    !signInNavigation.isSigningIn &&
    user.guessedHomeCountry === 'GB';
export const selectIsEligibleForMiniValueProof = (store) => isEligibleForMiniValueProof({
    featureFlags: store.utils.featureFlags,
    signInNavigation: store.signInNavigation,
    user: store.user.user,
});
